export default "__VITE_ASSET__BmLQp4$S__"